import { Component, Input, OnInit } from '@angular/core';
import { MatDialog, MatSnackBar } from '@angular/material';
import { NgxSpinnerService } from 'ngx-spinner';
import { IUser } from '../models/vk-users.model';
import { VkUsersService } from './../services/vk-users.service';
import { VkUsersModalComponent } from './modal/vk-users.modal';

@Component({
  selector: 'vk-users',
  templateUrl: 'vk-users.component.html',
  styleUrls: ['vk-users.component.scss']
})
export class VkUsersComponent implements OnInit {
  @Input() apiBaseUrl?: string;
  @Input() accessToken?: string;
  
  error;
  loadingUsers = true;
  users;
  _users;
  displayedColumns;

  constructor(
    private usersService: VkUsersService,
    private snackBar: MatSnackBar,
    private spinner: NgxSpinnerService,
    public dialog: MatDialog
    ) { }

  ngOnInit() {
    this.spinner.show();
    this.displayedColumns = ['createDate', 'userName', 'email', 'lastActivityDate', 'isApproved', 'isLockedOut', 'actions'];
    this.usersService.apiBaseUrl = this.apiBaseUrl;
    this.usersService.accessToken = this.accessToken;
    this.usersService.getAllUsers().subscribe(
      response => this.getAllUsersResponseHandler(response),
      () => this.getAllUsersResponseHandlerError()
    );
  }

  getAllUsersResponseHandler(response) {
    if (response.success) {
      this.users = response.data;
      this._users = this.users.sort((a, b) => a.UserName.localeCompare(b.UserName));
      this.loadingUsers = false;
      this.error = false; 
      this.spinner.hide;
    } else {
      this.showErrorMessage("ERROR: " + response.errorsMessages[0]);
      this.loadingUsers = false;
      this.error = true;
      this.spinner.hide;
    }
  }
  
  getAllUsersResponseHandlerError() {
    this.showErrorMessage("Ha ocurrido un error inesperado. Por favor, intente más tarde"); 
    this.loadingUsers = false;
    this.error = true;
    this.spinner.hide;
  }

  private showErrorMessage(message: string) { 
    this.snackBar.open(message, null, {duration: 5000});
  }

  getDate(date: string) {
    let dateWithFormat = new Date(date);
    return dateWithFormat.toLocaleDateString('en-GB');
  }

  openDialog(element?: IUser) {
    const dialogRef = this.dialog.open(VkUsersModalComponent, {
        data: {
          user: element
        },
        height: '530px',
        width: '562px',
    });

    dialogRef.afterClosed().subscribe(result => { this.ngOnInit() });
  }

  onCreate() {
    this.openDialog();
  }

  onEdit(element: IUser) {
    this.openDialog(element);
  }

  onView(element: IUser) {
    this.openDialog(element);
  }

  onSearch(event: any) {
    let users = this.users.filter(x => this.getDate(x.CreateDate).toString().toLowerCase().includes(event.toLowerCase()) 
    || this.getDate(x.LastActivityDate).toString().toLowerCase().includes(event.toLowerCase()) 
    || x.UserName.toLowerCase().includes(event.toLowerCase()) 
    || (x.Email || '').toLowerCase().includes(event.toLowerCase()));

    this._users = users.sort((a, b) => a.UserName.localeCompare(b.UserName));
  }

  onRefresh() {
    this.ngOnInit();
  }

}
